<template>
  <form @submit.prevent="onSubmit()">
    <p class="text-center text-bold">{{ $t('Type new password.') }}</p>
    <div class="form-group">
      <label
        >{{ $t('Password')
        }}<span class="ml-2 text-1 text-muted"
          >（{{ $t('{min}~{max} characters', { min: 8, max: 32 }) }}）</span
        ></label
      >
      <input
        v-validate="{ required: true, min: 8, max: 32 }"
        data-vv-validate-on="change"
        data-vv-as="Password"
        ref="confirm"
        name="password_field"
        class="form-control"
        :placeholder="$t('New Password')"
        type="password"
        maxlength="32"
        v-model="inputPassword"
      />
      <span v-if="errors.has('password_field')" class="text-2 text-danger">
        {{ errors.first('password_field') }}
      </span>
    </div>
    <div class="form-group">
      <label
        >{{ $t('Password')
        }}<span class="ml-2 text-1 text-muted">（{{ $t('Confirm') }}）</span></label
      >
      <input
        v-validate="{ required: true, confirmed: 'confirm' }"
        data-vv-validate-on="custom"
        data-vv-as="Confirm Password"
        name="confirm_field"
        class="form-control"
        :placeholder="$t('Confirm Password')"
        type="password"
        v-model="inputConfirmPassword"
      />
      <span v-if="errors.has('confirm_field')" class="text-2 text-danger">
        {{ errors.first('confirm_field') }}
      </span>
    </div>
    <div class="buttons-w">
      <div class="go-back">
        <span @click="goBack">{{ $t('Back') }}</span>
      </div>
      <div class="text-center">
        <Button nativeType="submit" :loading="isLoading" @click="onSubmit">
          {{ $t('Change password') }}</Button
        >
      </div>
    </div>
  </form>
</template>

<script>
import Button from '@/components/uikit/Button';

import jaTranslations from '@/i18n/langs/ja';
import enTranslations from '@/i18n/langs/en';

export default {
  name: 'StepWrapper',
  components: {
    Button,
  },
  props: {
    email: {
      type: String,
      default: '',
    },
    user: {
      type: Object,
    },
  },
  i18n: {
    en: {
      ...enTranslations,
    },
    ja: {
      ...jaTranslations,
    },
  },
  data() {
    return {
      isLoading: false,
      inputPassword: '',
      inputConfirmPassword: '',
      confirmFailed: true,
    };
  },
  watch: {
    inputPassword(value) {
      this.inputPassword = value.replace(/\s+/g, '');
    },
    inputConfirmPassword(value) {
      this.inputConfirmPassword = value.replace(/\s+/g, '');
    },
  },
  methods: {
    typeSomeKeys() {},
    onSubmit() {
      this.$validator.validate().then(result => {
        if (result) {
          this.isLoading = true;
          this.$store
            .dispatch('putResetPassword', {
              email: this.email,
              password: this.inputPassword,
              repassword: this.inputConfirmPassword,
              username: this.user.id,
              level: this.user.level,
            })
            .then(res => {
              this.isLoading = false;
              if (res.data.status === 'error') {
                throw new Error();
              } else {
                this.$emit('goForward', 3);
              }
            })
            .catch(() => {
              this.$message.error(this.$t('Failed to change password.'));
              this.isLoading = false;
            });
        } else {
          this.confirm = true;
        }
      });
    },
    goBack() {
      this.$router.push('/login').catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/mo-custom';

.buttons-w {
  display: flex;
  justify-content: space-between;
}
.go-back {
  span {
    color: $primary-color;
    cursor: pointer;
    line-height: 30px;
    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
